import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchCareerTable, fetchCareers, fetchCareerById, addCareer, updateCareer, removeCareer } from "../../api/careerApi";

// Async thunks for career operations

export const getCareersTable = createAsyncThunk(
  "career/getCareersTable",
  async ({ page, limit }: { page: number; limit: number }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchCareerTable(page, limit);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getCareerById = createAsyncThunk(
  "career/getCareerById",
  async (id: string, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchCareerById(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const createCareer = createAsyncThunk(
  "career/createCareer",
  async (newCareer: { role: string; location: string; employment_type: string }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await addCareer(newCareer);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const editCareer = createAsyncThunk(
  "career/editCareer",
  async ({ id, updatedCareer }: { id: string; updatedCareer: any }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await updateCareer(id, updatedCareer);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteCareer = createAsyncThunk(
  "career/deleteCareer",
  async (id: string, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await removeCareer(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Career Slice

const careerSlice = createSlice({
  name: "career",
  initialState: {
    careers: [] as any[],
    career: null as any | null,
    status: null as boolean | null,
    msg: "",
    error: null as string | null,
  },
  reducers: {
    resetStatus(state) {
      state.status = null;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Get all careers
      .addCase(getCareersTable.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.status = true;
        state.careers = action.payload;
      })
      .addCase(getCareersTable.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })
      
      // Get career by ID
      .addCase(getCareerById.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = true;
        state.career = action.payload;
      })
      .addCase(getCareerById.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })
      
      // Create career
      .addCase(createCareer.fulfilled, (state, action: PayloadAction<any>) => {
        if (Array.isArray(action.payload)) {
          state.careers.push(action.payload);
          state.status = true;
          state.msg = "Career created successfully.";
        } else {
          console.log("career not an array");
        }
      })
      
      // Edit career
      .addCase(editCareer.fulfilled, (state, action: PayloadAction<any>) => {
        const { id, data } = action.payload;
        if (Array.isArray(state.careers)) {
          const index = state.careers.findIndex((career) => career.id === id);
          if (index !== -1) {
            state.careers[index] = data;
          }
          state.status = true;
          state.msg = "Career updated successfully.";
        } else {
          console.log("career not an array");
        }
      })
      
      // Delete career
      .addCase(deleteCareer.fulfilled, (state, action: PayloadAction<string>) => {
        if (Array.isArray(state.careers)) {
          state.careers = state.careers.filter((career) => career.id !== action.payload);
          state.status = true;
          state.msg = "Career deleted successfully.";
        } else {
          console.log("career not an array");
        }
      });
  },
});

export const { resetStatus } = careerSlice.actions;
export default careerSlice.reducer;
